import { m } from 'framer-motion';
import { Col, Container } from 'react-bootstrap';
import { fadeIn } from '../../Functions/GlobalAnimations';
import BlogCategory from '../../Components/Blogs/BlogCategory';
import { BlogCategoryData } from '../../Components/Blogs/BlogData';
const BeneficiaryCorner = () => {
	return (
		<>
			<m.div className="mt-[200px] ">
				<Container>
					<Col xl={8} lg={10} className="text-center w-fit">
						<h3 className="font-serif text-[30px] mb-[2px] font-medium text-[#146084] ">
							Beneficiary Corner
						</h3>
						<m.div
							className="border-b border-1 w-[40%] border-[#146084]"
							initial={{ scaleX: 0 }}
							animate={{ scaleX: 1 }}
							transition={{ duration: 0.5, delay: 0.2 }}
						/>
					</Col>
					<div className="mt-[100px]">
						<BlogCategory
							grid="grid grid-3col xl-grid-3col lg-grid-3col md-grid-2col sm-grid-2col xs-grid-1col gutter-extra-large"
							data={BlogCategoryData}
							animation={fadeIn}
						/>
					</div>
				</Container>
			</m.div>
		</>
	);
};

export default BeneficiaryCorner;
